import { InputFieldAttributes } from '../mautic-form-types';
import clsx from 'clsx';
import { createFocusState, formatLabel } from '../utils';

export const Textarea = ({ fieldData }: { fieldData: InputFieldAttributes }) => {
    const {
        alias,
        defaultValue,
        errors,
        id,
        inputClasses,
        inputLabelClasses,
        isRequired,
        label,
        value,
        handleChange,
        revalidate,
        errorInputClasses,
        errorLabelClasses,
        errorId,
    } = fieldData;
    const { isFocused, onFocus, onBlur } = createFocusState();
    const error = () => Boolean(errors[alias]);

    const stringID = String(id);

    const placeholder = `${defaultValue ?? label}${isRequired ? ' *' : ''}`;

    return (
        <div class="relative">
            <label
                class={inputLabelClasses}
                classList={{
                    'top-xxs text-paragraphXS': isFocused() || !!value,
                    'sr-only': !isFocused() && !!value === false,
                    [errorLabelClasses || '']: error(),
                }}
                for={stringID}
            >
                {formatLabel(label, isRequired)}
            </label>
            <div
                class='after:pt-s after:pb-xxs after:px-xs grid after:invisible after:whitespace-pre-wrap after:rounded-s after:border-2 after:content-[attr(data-cloned-val)_"_"] after:[grid-area:1/1/2/2]'
                data-cloned-val={typeof value === 'boolean' ? String(value) : value || ' '}
            >
                <textarea
                    {...(error() && { 'aria-invalid': true, 'aria-describedby': errorId })}
                    class={clsx(inputClasses, 'resize-none overflow-hidden [grid-area:1/1/2/2]')}
                    classList={{
                        'pt-s pb-xxs': isFocused() || !!value,
                        [errorInputClasses || '']: error(),
                    }}
                    id={stringID}
                    onBlur={(e) => {
                        onBlur(e.target.value !== '');
                        revalidate(alias, e.target.value);
                    }}
                    onChange={(e) => handleChange(alias, e.target.value)}
                    onInput={(e) => {
                        const target = e.target as HTMLTextAreaElement;
                        target.parentElement!.dataset.clonedVal = target.value || ' ';
                    }}
                    onFocus={onFocus}
                    placeholder={!isFocused() ? placeholder : ''}
                    rows={2}
                    value={typeof value === 'boolean' ? String(value) : value}
                />
            </div>
        </div>
    );
};
